import { Col, Row } from "react-bootstrap";
import { LoginWithPhoneWrapper } from "./styled";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import PhoneSigninForm from "./components/PhoneSigninForm";
import {
  Box,
  FormButtonStyled,
  LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { LoginRightImage } from "../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LoginWithPhone = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <LoginWithPhoneWrapper lang={i18n.language}>
      <AuthHeader />
      <Box className="mt-4 container-fluid pb-4">
        <Row>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 px-md-5">
            <PhoneSigninForm />
            <Box>
              <Box>
                <TextStyled
                  className="justify-content-center align-items-center or-separator"
                  color="var(--text2)"
                  size="16px"
                >
                  {t("or")}
                </TextStyled>
              </Box>
            </Box>
            <FormButtonStyled
              label={t("login_with_email")}
              color="var(--text)"
              bg="var(--white)"
              className="w-100"
              clName="w-100 my-4"
              weight="600"
              onClick={() => navigate("/")}
            />
            <p className="text-center" style={{ color: "var(--text2)" }}>
              {t("dont_have_an_account")}{" "}
              <span
                onClick={() => navigate("/signup")}
                style={{ color: "var(--themeColor)", cursor: "pointer" }}
              >
                {t("sign_up")}
              </span>
            </p>
          </Col>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
            <Box className="sticky-item">
              <Box style={{ position: "relative" }}>
                <Box className="image-title">
                  <Box>
                    <span className="image-title-one">{t("welcome_to")} </span>{" "}
                    <span className="image-title-two">{t("my_office")}</span>
                  </Box>
                  <p className="image-title-sub-title">
                    {t("streamline_your_workspace")}
                  </p>
                </Box>
                <LazyImage src={LoginRightImage} />
              </Box>
            </Box>
          </Col>
        </Row>
      </Box>
    </LoginWithPhoneWrapper>
  );
};

export default LoginWithPhone;
